import { FormControlLabel, IconButton, Switch, Tooltip, Typography } from '@mui/material'
import SwapVertIcon from '@mui/icons-material/SwapVert'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'

/**
 * What the bar of a machine's tab adds next to the search (contract §8): the resequencing preview switch, which
 * decides whether the field, the arrows and the menu show the preview before moving, and the button that shows or
 * hides the arrows. Both are the user's preferences (saved in Sun by the panel); neither needs
 * "PLANNER_DETAIL_ORDER" and neither touches the selected fabrication order.
 *
 * @param {Object} props
 * @param {Boolean} props.previewOn The switch
 * @param {Function} props.onTogglePreview
 * @param {Boolean} props.arrowsVisible
 * @param {Function} props.onToggleArrows
 */
const SequenceToolbarControls = ({ previewOn, onTogglePreview, arrowsVisible, onToggleArrows }) => {
  const { t_ } = useSmartTranslation()
  const arrowsLabel = arrowsVisible ? t_('Hide arrows') : t_('Show arrows')
  return (
    <>
      <FormControlLabel
        sx={{ m: 0, whiteSpace: 'nowrap' }}
        control={<Switch size='small' checked={previewOn} onChange={onTogglePreview} />}
        label={<Typography variant='body2'>{t_('Resequencing preview')}</Typography>}
      />
      <Tooltip title={arrowsLabel}>
        <IconButton aria-label={arrowsLabel} aria-pressed={arrowsVisible} color={arrowsVisible ? 'primary' : 'default'} onClick={onToggleArrows}>
          <SwapVertIcon />
        </IconButton>
      </Tooltip>
    </>
  )
}

export default SequenceToolbarControls
